module.exports = __webpack_public_path__ + "3f16e137/img/document.e2130c6b.svg";